import {useCallback} from 'react';

import {useLocale} from '../../provider/locale/locale-hook';
import {DateTimeFormatOptionsType, getFormattedDateTime, getFormattedNumber, NumberFormatOptionsType} from '../format';

import {UseFormatHookType} from './format-hook-type';

export function useFormat(): UseFormatHookType {
    const localeContext = useLocale();
    const {localeName} = localeContext;

    const getFormattedNumberWrapper = useCallback(
        (value: number, options?: NumberFormatOptionsType): string => {
            return getFormattedNumber(localeName, value, options);
        },
        [localeName]
    );

    const getFormattedDateTimeWrapper = useCallback(
        (date: Date | number, options?: DateTimeFormatOptionsType): string => {
            return getFormattedDateTime(localeName, date, options);
        },
        [localeName]
    );

    return {
        getFormattedNumber: getFormattedNumberWrapper,
        getFormattedDateTime: getFormattedDateTimeWrapper,
    };
}
